import {
  IsBoolean,
  IsDate,
  IsNumber,
  IsObject,
  IsOptional,
  IsString,
  Max,
  Min
} from 'class-validator';
import { BaseDto } from '../base.dto';
import { GiftCardEmailTemplateDto } from './giftCardEmailTemplate.dto';
import { MerchantDto } from '../merchant.dto';
import type { GiftCardBenefitSetupDto } from './giftCardBenefitSetup.dto';
import type { BrandDto } from '../brand.dto';
import { Type } from 'class-transformer';
import { MAX_DIGITAL_CARD_AMOUNT, MIN_DIGITAL_CARD_AMOUNT } from "../../constants";

export const CARD_TYPE_MIN_EXPIRY_DAYS = 1;
export const CARD_TYPE_MAX_EXPIRY_DAYS = 1826;

export class GiftCardTypeDto extends BaseDto {
  @IsString()
  typeName?: string;

  @IsString()
  @IsOptional()
  photoURL?: string;

  @IsString()
  message: string;

  @Type(() => Date)
  @IsDate()
  startDate?: Date;

  @Type(() => Date)
  @IsDate()
  @IsOptional()
  endDate?: Date;

  @IsNumber()
  templateId?: number;

  @IsNumber()
  @IsOptional()
  physicalProcessedTemplateId?: number;

  template: GiftCardEmailTemplateDto;
  merchants: any;

  @IsBoolean()
  @IsOptional()
  public?: boolean;

  @IsNumber()
  @IsOptional()
  registrationTemplateId?: number;
  registrationTemplate?: GiftCardEmailTemplateDto;

  @IsBoolean()
  @IsOptional()
  isPhysicalCard?: boolean;

  @IsBoolean()
  @IsOptional()
  isFixedAmount?: boolean;

  @IsNumber()
  @Min(MIN_DIGITAL_CARD_AMOUNT)
  @Max(MAX_DIGITAL_CARD_AMOUNT)
  @IsOptional()
  fixedAmount?: number;

  @IsNumber()
  @IsOptional()
  price?: number;

  @IsString()
  description?: string;

  @IsNumber()
  sequence?: number;

  @IsNumber()
  merchantId?: number;

  @IsBoolean()
  @IsOptional()
  hasExpiry: boolean;

  @IsNumber()
  @IsOptional()
  @Min(CARD_TYPE_MIN_EXPIRY_DAYS)
  @Max(CARD_TYPE_MAX_EXPIRY_DAYS)
  expiryDays: number;

  @IsBoolean()
  isMealCard: boolean;

  @IsNumber()
  @IsOptional()
  benefitSetupId?: number;

  @IsObject()
  @IsOptional()
  benefitSetup?: GiftCardBenefitSetupDto;

  activeByDate: boolean;

  @IsOptional()
  @IsNumber()
  brandId?: number;

  @IsOptional()
  @IsObject()
  brand?: BrandDto;
  
  constructor(
    input?: Partial<{
      id?: number;
      createdDate?: Date;
      modifiedDate?: Date;
      lastModifiedUserId?: number;
      version?: number;
      aclEnabled?: boolean;
      aclEntryId?: number;
      typeName?: string;
      photoURL?: string;
      message: string;
      startDate?: Date;
      endDate?: Date;
      templateId?: number;
      physicalProcessedTemplateId?: number;
      template: GiftCardEmailTemplateDto;
      merchants: MerchantDto[];
      public?: boolean;
      registrationTemplateId?: number;
      registrationTemplate?: GiftCardEmailTemplateDto;
      isPhysicalCard?: boolean;
      isFixedAmount?: boolean;
      fixedAmount?: number;
      price?: number;
      description?: string;
      sequence?: number;
      merchantId?: number;
      hasExpiry: boolean;
      expiryDays: number;
      isMealCard: boolean;
      benefitSetupId?: number;
      benefitSetup?: GiftCardBenefitSetupDto;
      brandId?: number;
      brand?: BrandDto;
    }>
  ) {
    super();
    this.id = input?.id;
    this.createdDate = input?.createdDate;
    this.modifiedDate = input?.modifiedDate;
    this.lastModifiedUserId = input?.lastModifiedUserId;
    this.version = input?.version;
    this.aclEnabled = input?.aclEnabled;
    this.aclEntryId = input?.aclEntryId;
    this.typeName = input?.typeName;
    this.photoURL = input?.photoURL;
    this.message = input?.message;
    this.startDate = input?.startDate;
    this.endDate = input?.endDate;
    this.templateId = input?.templateId;
    this.physicalProcessedTemplateId = input?.physicalProcessedTemplateId;
    this.template = input?.template;
    this.merchants = input?.merchants;
    this.public = input?.public;
    this.registrationTemplateId = input?.registrationTemplateId;
    this.registrationTemplate = input?.registrationTemplate;
    this.isPhysicalCard = input?.isPhysicalCard;
    this.isFixedAmount = input?.isFixedAmount ?? false;
    this.fixedAmount = input?.fixedAmount;
    this.price = input?.price;
    this.description = input?.description;
    this.sequence = input?.sequence;
    this.merchantId = input?.merchantId;
    this.hasExpiry = input?.hasExpiry ?? false;
    this.expiryDays = input?.expiryDays;
    this.isMealCard = input?.isMealCard ?? false;
    this.benefitSetupId = input?.benefitSetupId;
    this.benefitSetup = input?.benefitSetup;
    this.brandId = input?.brandId;
    this.brand = input?.brand;
  }
}
